export default __webpack_public_path__ + "static/sonic-automotive.png";